import "./style/Nav.css";
import dash_icon from "../assets/dashboard/nav-icon/Group 113.png";
import time_icon from "../assets/dashboard/nav-icon/Group 52.png";
import book_icon from "../assets/dashboard/nav-icon/Group 43.png";
// import report_card_icon from '../assets/dashboard/nav-icon/Group 44.png';
import list_icon from "../assets/dashboard/nav-icon/Group 45.png";
import store_icon from "../assets/dashboard/nav-icon/Group 46.png";
import financial_icon from "../assets/dashboard/nav-icon/Group 47.png";
import support_icon from "../assets/dashboard/nav-icon/Group 48.png";
// import setting_icon from '../assets/dashboard/nav-icon/Group 49.png';
// import light_icon from '../assets/dashboard/nav-icon/Group 50.png';
// import star_icon from '../assets/dashboard/nav-icon/Vector.png';
import exit_icon from "../assets/dashboard/nav-icon/Group 53.png";
import user_icon from "../assets/dashboard/nav-icon/Group 958.png";

import dash_icon_active from "../assets/dashboard/nav-icon/vuesax-linear-element-3.png";
import time_icon_active from "../assets/dashboard/nav-icon/Group 101.png";
import book_icon_active from "../assets/dashboard/nav-icon/Group 102.png";
// import report_card_icon_active from '../assets/dashboard/nav-icon/Group 103.png';
import list_icon_active from "../assets/dashboard/nav-icon/Group 104.png";
import store_icon_active from "../assets/dashboard/nav-icon/Group 105.png";
import financial_icon_active from "../assets/dashboard/nav-icon/Group 108.png";
import support_icon_active from "../assets/dashboard/nav-icon/Group 109.png";
// import setting_icon_active from '../assets/dashboard/nav-icon/Group 110.png';
// import light_icon_active from '../assets/dashboard/nav-icon/Group 111.png';
// import star_icon_active from '../assets/dashboard/nav-icon/112.png';
import user_icon_active from "../assets/dashboard/nav-icon/Group 958-active.png";

import { RiPushpin2Line } from "react-icons/ri";

// import { Category,Message,Setting,Calendar,Wallet,Star,Activity } from 'react-iconly';
import { useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../redux/index";

// console.log(document.documentElement.clientHeight);
// document.querySelector(".nav").style.height=document.height;

let loc = window.location.pathname;
let loc_list = [
  true,
  false,
  false,
  false,
  false,
  false,
  false,
  false,
  false,
  false,
];
let old_nav_item_id = 1;
let old_nav_item_sub_id = 1;
if (loc === "/") {
  loc_list = [
    true,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ];
  old_nav_item_id = 1;
  old_nav_item_sub_id = 1;
} else if (loc.includes("/store")) {
  loc_list = [
    false,
    false,
    false,
    false,
    true,
    false,
    false,
    false,
    false,
    false,
  ];
  old_nav_item_id = 5;
  old_nav_item_sub_id = 1;
} else if (loc.includes("/azmoon_list")) {
  loc_list = [
    false,
    false,
    false,
    true,
    false,
    false,
    false,
    false,
    false,
    false,
  ];
  old_nav_item_id = 4;
  old_nav_item_sub_id = 1;
} else if (loc.includes("/calendar")) {
  loc_list = [
    false,
    true,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ];
  old_nav_item_id = 2;
  old_nav_item_sub_id = 1;
} else if (loc.includes("/blog")) {
  loc_list = [
    false,
    false,
    true,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ];
  old_nav_item_id = 3;
  old_nav_item_sub_id = 1;
} else if (loc.includes("/profile")) {
  loc_list = [
    false,
    false,
    false,
    false,
    false,
    false,
    true,
    false,
    false,
    false,
  ];
  old_nav_item_id = 2;
  old_nav_item_sub_id = 2;
}else if (loc.includes("/messages")) {
  loc_list = [
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    true,
    false,
    false,
  ];
  old_nav_item_id = 3;
  old_nav_item_sub_id = 2;
}

let inital_nav_list = [
  {
    id: 1,
    title: "منوی کاربری",
    subset: [
      {
        id: 1,
        sub_id: 1,
        name: "داشبورد مدیریتی",
        // icon:<Category className="nav-item-icon"/>
        icon: dash_icon,
        icon_active: dash_icon_active,
        // navItemIsActive: true,
        navItemIsActive: loc_list[0],
        path: "/dashboard",
        badge:false
      },
      {
        id: 2,
        sub_id: 1,
        name: "زمان بندی آزمون‌ها",
        // icon:<Calendar className="nav-item-icon"/>
        icon: time_icon,
        icon_active: time_icon_active,
        // navItemIsActive:false,
        navItemIsActive: loc_list[1],
        path: "/dashboard/calendar",
        badge:false
      },
      {
        id: 3,
        sub_id: 1,
        name: "وبلاگ",
        icon: book_icon,
        icon_active: book_icon_active,
        // navItemIsActive:false,
        navItemIsActive: loc_list[2],
        path: "/dashboard/blog",
        badge:false
      },
      // {
      //   id:4,
      //   sub_id:1,
      //   name:"نتایج آزمون‌ها",
      //   // icon:<Activity className="nav-item-icon"/>
      //   icon:report_card_icon,
      //   icon_active:report_card_icon_active,
      //   // navItemIsActive:false,
      //   navItemIsActive: loc_list[3],
      //   path:"/dashboard",
      // },
      {
        id: 4,
        sub_id: 1,
        name: "لیست آزمون‌ها",
        icon: list_icon,
        icon_active: list_icon_active,
        // navItemIsActive:false,
        navItemIsActive: loc_list[3],
        path: "/dashboard/azmoon_list",
        badge:false
      },
      {
        id: 5,
        sub_id: 1,
        name: "فروشگاه",
        icon: store_icon,
        icon_active: store_icon_active,
        // navItemIsActive:false,
        navItemIsActive: loc_list[4],
        path: "/dashboard/store",
        badge:false
      },
    ],
  },
  {
    id: 2,
    title: "حسابداری و پشتیبانی",
    subset: [
      {
        id: 1,
        sub_id: 2,
        name: "مالی و حسابداری",
        // icon:<Wallet className="nav-item-icon"/>
        icon: financial_icon,
        icon_active: financial_icon_active,
        // navItemIsActive:false,
        navItemIsActive: loc_list[5],
        path: "/dashboard/financial",
        badge:false
      },
      {
        id: 2,
        sub_id: 2,
        name: "حساب کاربری",
        // icon:<Message className="nav-item-icon"/>
        icon: user_icon,
        icon_active: user_icon_active,
        // navItemIsActive:false,
        navItemIsActive: loc_list[6],
        path: "/dashboard/profile",
        badge:false
      },
      {
        id: 3,
        sub_id: 2,
        name: "پیام‌ها",
        // icon:<Message className="nav-item-icon"/>
        icon: support_icon,
        icon_active: support_icon_active,
        // navItemIsActive:false,
        navItemIsActive: loc_list[7],
        path: "/dashboard/messages",
        badge:true
      },
    ],
  },
  // {
  //   id:3,
  //   title:"تنظیمات و راهنما",
  //   subset:[
  //     {
  //       id:1,
  //       sub_id:3,
  //       name:"تنظیمات",
  //       // icon:<Setting className="nav-item-icon"/>
  //       icon:setting_icon,
  //       icon_active:setting_icon_active,
  //       // navItemIsActive:false,
  //       navItemIsActive: loc_list[7],
  //       path:"/dashboard",
  //     },
  //     {
  //       id:2,
  //       sub_id:3,
  //       name:"راهنما",
  //       icon:light_icon,
  //       icon_active:light_icon_active,
  //       // navItemIsActive:false,
  //       navItemIsActive: loc_list[8],
  //       path:"/dashboard",
  //     },
  //     {
  //       id:3,
  //       sub_id:3,
  //       name:"علاقه‌مندی‌ها",
  //       // icon:<Star set="curved" className="nav-item-icon"/>
  //       icon:star_icon,
  //       icon_active:star_icon_active,
  //       // navItemIsActive:false,
  //       navItemIsActive: loc_list[9],
  //       path:"/dashboard",
  //     },
  //   ]
  // },
];

let navPinisActive = false;
const Nav = () => {
  // console.log(document.getElementById("NAV"));

  const [nav_list, set_nav_list] = useState(inital_nav_list);
  const [onii, set_onii] = useState(old_nav_item_id);
  const [onisi, set_onisi] = useState(old_nav_item_sub_id);
  const [navOpen,setNavOpen] = useState(false);

  const dispatch = useDispatch();
  const { open_nav, close_nav } = bindActionCreators(actionCreators, dispatch);

  const nav_open = () => {
    if (!navPinisActive) {
      // console.log(document.querySelector(".nav"));
      document.querySelector(".nav").classList.add("nav_hover");
      let nin = document.querySelectorAll(".nav-item-name");
      for (let i = 0; i < nin.length; i++) {
        nin[i].classList.add("nav-item-name-hover");
      }
      let nst = document.querySelectorAll(".nav-section-title");
      for (let i = 0; i < nst.length; i++) {
        nst[i].classList.add("nav-section-title-hover");
      }
      setNavOpen(true);
    }
    document.querySelector(".nav-pin").classList.add("nav-pin-hover");
  };

  const nav_close = () => {
    if (!navPinisActive) {
      document.querySelector(".nav").classList.remove("nav_hover");
      let nin = document.querySelectorAll(".nav-item-name");
      for (let i = 0; i < nin.length; i++) {
        nin[i].classList.remove("nav-item-name-hover");
      }
      let nst = document.querySelectorAll(".nav-section-title");
      for (let i = 0; i < nst.length; i++) {
        nst[i].classList.remove("nav-section-title-hover");
      }
      setNavOpen(false);
    }
    document.querySelector(".nav-pin").classList.remove("nav-pin-hover");
  };

  // let navPinisActive = false;
  const nav_is_pin = (e) => {
    if (!navPinisActive) {
      e.target.style.color = "#111";
      open_nav();
    } else if (navPinisActive) {
      e.target.style.color = "#B5B5B5";
      close_nav();
    }
    navPinisActive = !navPinisActive;
  };

  // let old_nav_item_id = 1;
  // let old_nav_item_sub_id = 1;

  const nav_item_choose = (id, sub_id) => {
    // console.log(old_nav_item_id, old_nav_item_sub_id);
    let new_nav_list = nav_list.map((item) => {
      item.subset.map((item) => {
        if (item.id === onii && item.sub_id === onisi) {
          item.navItemIsActive = false;
        }
        if (item.id === id && item.sub_id === sub_id) {
          item.navItemIsActive = true;
        }
        return { ...item };
      });
      return { ...item };
    });
    set_nav_list(new_nav_list);
    set_onii(id);
    set_onisi(sub_id);
  };
  return (
    <div
      className="nav"
      id="NAV"
      onMouseEnter={nav_open}
      onMouseLeave={nav_close}
    >
      {navOpen && <div className="nav-logo">
        آزما | <span style={{ fontSize: 17 }}>پلتفرم جامع آزمون</span>
      </div>}
      {!navOpen && <div className="nav-short-logo">
      | آزما
      </div>}
      <div className="nav-pin">
        <RiPushpin2Line className="nav-pin-icon" onClick={nav_is_pin} />
      </div>
      {nav_list.map((item) => (
        <div key={item.id} className="nav-section">
          <div className="nav-section-title">{item.title}</div>
          {item.subset.map((item) => (
            <Link
              to={item.path}
              style={
                item.navItemIsActive
                  ? { backgroundColor: "rgba(46,129,232,0.06)" }
                  : null
              }
              key={item.id}
              className="nav-item"
              onClick={() => nav_item_choose(item.id, item.sub_id)}
            >
              {item.navItemIsActive && (
                <div className="nav-item-line-bar"></div>
              )}
              {/* <img src={item.icon} alt="nav-icon" className="nav-item-icon" /> */}
              <div className="nav-item-icon-container">
                {/* {item.icon} */}
                {item.navItemIsActive && (
                  <img
                    src={item.icon_active}
                    alt="nav-icon"
                    className="nav-item-icon"
                  />
                )}
                {!item.navItemIsActive && (
                  <img
                    src={item.icon}
                    alt="nav-icon"
                    className="nav-item-icon"
                  />
                )}
              </div>
              <div
                style={item.navItemIsActive ? { color: "#2E81E8" } : null}
                className="nav-item-name"
              >
                {item.name}
              </div>
              {item.badge && <div className="nav-item-badge">2</div>}
            </Link>
          ))}
          <div className="nav-section-line"></div>
        </div>
      ))}
      <div className="nav-item exit-nav-item">
        {/* <img src={item.icon} alt="nav-icon" className="nav-item-icon" /> */}
        <div className="nav-item-icon-container">
          {/* {item.icon} */}
          <img src={exit_icon} alt="nav-icon" className="nav-item-icon" />
        </div>
        <div className="nav-item-name exit-nav-item-name">
          خروج از حساب کاربری
        </div>
      </div>
    </div>
  );
};

export default Nav;
